import 'css-chunk:src/feature/pay-in-out/PayInOutPage.module.scss';export default {
  "root": "PayInOutPage_root"
};